module.exports = __webpack_public_path__ + "img/icon-sales-person-slim.eed94c0d.svg";